export enum OperationType {
  Archive = 'archive',
  UnArchive = 'unarchive',
}

export type ArchiveOperationRequestDto = {
  type: OperationType.Archive;
  archivePath?: string;
  /**
   * Whether to transfer only media files to the archive location if configured.
   */
  mediaOnly?: boolean;
  pending?: boolean;
} | {
  type: OperationType.UnArchive;
};

export interface ArchiveOperationResponseDto {
  type: OperationType;
  payload: {
    folderId: string;
    folderName?: string;
  };
}

